<template>
  <vue-splitter
    :margin="30"
    :horizontal="horizontal"
    style="display: flex; height:  100%; overflow: hidden "
  >
    <groups
      slot="left-pane"
      @choice="choice"
    />
    <group-config
      slot="right-pane"
      :group="cur_group"
      :clients="clients"
    />
  </vue-splitter>
</template>

<script>
import GroupConfig from './DeviceGroup/DeviceConfig'
import Groups from './DeviceGroup/DeviceGroups'
import VueSplitter from '@rmp135/vue-splitter'
export default {
  name: 'DeviceGroups',
  components: {
    GroupConfig,
    VueSplitter,
    Groups
  },
  data () {
    return {
      new_group: '',
      cur_group: {},
      clients: []
    }
  },
  mounted(){
    this.get_clients()
  },
  computed:{
    horizontal(){
      return document.documentElement.clientWidth <= 768;
    }
  },
  methods: {
    choice (group) {
      this.cur_group = group
    },
    get_clients(){
      this.$http.v1.getClients((response) => {
        this.clients = response.data
      })
    }
  }
}
</script>
